<template>
  <v-container fluid>
    <NavDrawer></NavDrawer>
    <AppBar>
      <v-snackbar
        :color="appMessage.color || 'primary'"
        :value="appMessage"
        :absolute="false"
        :top="appMessage.position && appMessage.position.indexOf('top') !== -1"
        :bottom="appMessage.position && appMessage.position.indexOf('bottom') !== -1"
        :left="appMessage.position && appMessage.position.indexOf('left') !== -1"
        :right="appMessage.position && appMessage.position.indexOf('right') !== -1"
        :multi-line="appMessage.multiLine"
        :timeout="appMessage.timeout"
        v-if="appMessage"
      >
        {{ appMessage.text }}
        <template v-slot:action="{ attrs }">
          <v-btn color="grey darken-4" text v-bind="attrs" @click="closeNotify()">Close</v-btn>
          <v-btn color="grey darken-4" text v-bind="attrs" @click="closeNotify(appMessage.clickAction)" v-if="typeof appMessage.clickAction === 'function'">{{appMessage.clickLabel || 'More'}}</v-btn>
        </template>
      </v-snackbar>
    </AppBar>
    <ProfileDialog v-if="profileDialog"></ProfileDialog>
    <router-view name="app"></router-view>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import ProfileDialog from "@/components/config/user/Profile";
import AppBar from "@/components/AppBar";
import NavDrawer from "@/components/NavDrawer";

export default {
  data: () => ({}),
  computed: {
    ...mapGetters("app", ["appMessage", "profileDialog"]),
  },
  components: {
    AppBar,
    NavDrawer,
    ProfileDialog
  }
};
</script>